"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FallbackIntlProvider;

var _react = _interopRequireDefault(require("react"));

var _reactIntl = require("react-intl");

var _helpers = require("../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FallbackIntlProvider(_ref) {
  var messages = _ref.messages,
      children = _ref.children,
      locale = _ref.locale,
      defaultLocale = _ref.defaultLocale;
  return /*#__PURE__*/_react.default.createElement(_reactIntl.IntlProvider, {
    locale: locale || (0, _helpers.getLocale)(),
    defaultLocale: defaultLocale || (0, _helpers.getDefaultLocale)(),
    messages: messages
  }, children);
}